import { __rest, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default, { createContext, useContext } from 'react';
import { Link } from './../../external_lib/react-router-dom/esm/react-router-dom.js';
import { Router } from './../../external_lib/react-router/esm/react-router.js';

// Router context for handling routing in Storybook
var RouterContext = createContext({
  hasRouter: false
});
// Custom Link component that uses context to determine if router is available
var CustomLink = function (_a) {
  var children = _a.children,
    to = _a.to,
    props = __rest(_a, ["children", "to"]);
  var hasRouter = useContext(RouterContext).hasRouter;
  if (hasRouter) {
    return React__default.createElement(Link, __assign({
      to: to
    }, props), children);
  }
  return React__default.createElement(React__default.Fragment, null, children);
};
var hasRouterContext = function (routerProps) {
  var _a;
  return !!((_a = routerProps === null || routerProps === void 0 ? void 0 : routerProps.history) === null || _a === void 0 ? void 0 : _a.location);
};
var RouterWrapper = function (_a) {
  var children = _a.children,
    routerProps = _a.routerProps;
  var hasRouter = hasRouterContext(routerProps);
  // Only use Router if we have a proper history object
  if (hasRouter) {
    return React__default.createElement(RouterContext.Provider, {
      value: {
        hasRouter: hasRouter
      }
    }, React__default.createElement(Router, {
      history: routerProps.history
    }, children));
  }
  // Fallback for Storybook or when no router context is provided
  return React__default.createElement(RouterContext.Provider, {
    value: {
      hasRouter: hasRouter
    }
  }, children);
};
export { CustomLink, RouterContext, RouterWrapper, hasRouterContext };
//# sourceMappingURL=index.js.map
